import styled from '@emotion/styled';

export const LeftAlign = styled.div`
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const RightAlign = styled.div<{ colour?: string }>`
  display: flex;
  justify-content: flex-start;
  ${({ colour }) => (colour ? `color: ${colour}` : '')};
`;

export const BadgeWrap = styled.div`
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
`;

export const TableDate = styled.div`
  font-weight: var(--ds-fontWeights-regular);
  font-size: var(--ds-fontSizes-xs);
  line-height: var(--ds-lineHeights-4);
  color: var(--ds-colors-muted);
  order: 2;
  width: 100%;
`;
